
import { defineComponent } from "vue";
import type { PropType } from "vue";
import LoadingSpinnerComponent from "@/components/generic/LoadingSpinnerComponent.vue";

export type ButtonVariant = "primary" | "secondary" | "success" | "danger" | "warning";

/**
 * Shared button. Renders the global .btn system (src/scss/theme.scss): outline by default, `solid` = filled. `loading` shows a spinner
 * (replacing the icon) and disables the button.
 */
export default defineComponent({
  name: "BaseButton",
  components: { LoadingSpinnerComponent },
  props: {
    variant: { type: String as PropType<ButtonVariant>, default: "primary" },
    size: { type: String as PropType<"sm" | "md" | "lg">, default: "md" },
    icon: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    solid: { type: Boolean, default: false },
    /** Left unset by default so the browser default (submit inside forms) is kept, as before. */
    type: { type: String as PropType<"button" | "submit" | "reset">, default: undefined },
  },
  emits: ["click"],
  computed: {
    classes(): unknown[] {
      const variant = this.solid ? `btn-${this.variant}` : `btn-outline-${this.variant}`;
      const size = this.size === "md" ? "" : `btn-${this.size}`;
      return ["btn", variant, size, { "w-100": this.block }];
    },
  },
});
